import { getRoot, IAnyStateTreeNode } from 'mobx-state-tree';
import { IApp } from '../App';

export default (self: IAnyStateTreeNode) => getRoot<any>(self) as IApp;
